<template>
    <div>
        <div class="crumbs">
            <Breadcrumb v-bind:menuList="menuList"></Breadcrumb>
        </div>

        <div class="container">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="订单编号:">
                    <el-input v-model="queryParams.ordersn" placeholder="请输入订单编号" clearable></el-input>
                </el-form-item>
              <el-form-item label="用户手机号:" >
                <el-input v-model="queryParams.user_phone" placeholder="请输入用户手机号" clearable></el-input>
              </el-form-item>
              <el-form-item label="收货人手机号:" >
                <el-input v-model="queryParams.receive_phone" placeholder="请输入收货人手机号" clearable></el-input>
              </el-form-item>
                <el-form-item label="订单起止时间:" prop="time">
                    <el-date-picker ref="drawDate" style="margin-left: 5px;" v-model="queryParams.time" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable @change="changeQuery">
                    </el-date-picker>
                </el-form-item>
                <div style="float: right">
                    <el-button type="primary" @click="changeQuery()">搜索</el-button>
                </div>
            </el-form>
            <div>
                <el-radio-group v-model="tabPosition" style="margin-bottom:20px;" @change="changState">
                    <el-radio-button label="all">全部</el-radio-button>
                    <el-radio-button label="1">待付款</el-radio-button>
                    <el-radio-button label="2">待发货</el-radio-button>
                    <el-radio-button label="3">已发货</el-radio-button>
                    <el-radio-button label="4">已完成</el-radio-button>
                    <el-radio-button label="5">用户取消</el-radio-button>
                    <el-radio-button label="6">平台取消</el-radio-button>
                    <el-radio-button label="7">系统自动取消</el-radio-button>
                </el-radio-group>
            </div>
            <div class="action">
                <el-button type="primary" @click="exportFile">导出</el-button>
                <el-upload style="display:inline-block;margin-left:10px" class="upload-demo" action="/i/admin/order/import/deliver" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" name="file" :headers="header">
                    <el-button size="small" type="success" v-if="tabPosition === '2'">导入发货单</el-button>
                </el-upload>
            </div>
            <!-- 表格内容 -->
            <el-table v-loading="loading" :data="pageInfo.list" element-loading-text="数据加载中" stripe border ref="multipleTable" style="margin-top:20px">
                <el-table-column prop="id" label="id" width="80" align="center"></el-table-column>
                <el-table-column prop="uid" label="用户id" width="80" align="center"></el-table-column>
                <el-table-column prop="ordersn" label="订单编号" width="200" align="center"></el-table-column>
                <el-table-column prop="pay_number" label="支付编号" width="200" align="center"></el-table-column>
                <el-table-column prop="addr.username" label="收货人" width="120" align="center"></el-table-column>
                <el-table-column prop="addr.phone" label="手机号" width="120" align="center"></el-table-column>
                <el-table-column prop="count" label="共几款商品" width="120" align="center"></el-table-column>
                <el-table-column prop="price" label="实付金额" width="120" align="center"></el-table-column>
                <el-table-column prop="discount_price" label="优惠金额" width="120" align="center"></el-table-column>
                <el-table-column prop="ctime" label="订单时间" width="150" align="center"></el-table-column>
                <el-table-column prop="remark" label="订单备注" width="150" align="center"></el-table-column>
                <el-table-column prop="coupon_id" label="是否使用优惠券" width="120" align="center">
                    <template slot-scope="scope" prop="coupon_id">
                        <el-tag type="info" v-if="scope.row.coupon_id === 0">未使用</el-tag>
                        <el-tag type="primary" v-else>使用</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="is_refund" label="是否含售后" width="120" align="center">
                    <template slot-scope="scope" prop="is_refund">
                        <el-tag type="info" v-if="scope.row.refund_id === 1">不包含</el-tag>
                        <el-tag type="primary" v-if="scope.row.refund_id === 2">包含</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="支付状态" align="center">
                    <template slot-scope="scope">
                        <el-tag type="info" v-if="scope.row.pay_state === 0">未付款</el-tag>
                        <el-tag type="primary" v-if="scope.row.pay_state === 2">已付款</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="订单状态" align="center">
                    <template slot-scope="scope">
                        <el-tag type="primary" v-if="scope.row.state === 1">待发货</el-tag>
                        <el-tag type="primary" v-if="scope.row.state === 2">已完成</el-tag>
                        <el-tag type="primary" v-if=" scope.row.state === 3">已发货</el-tag>
                        <el-tag type="primary" v-if="scope.row.state === 4 || scope.row.state === 5 || scope.row.state === 6 ">已取消</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center" width="150" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" @click="tiao(scope.$index, scope.row)">订单详情</el-button>
                        <el-button type="text" icon="el-icon-edit" @click="edit(scope.$index, scope.row)">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination v-bind:pageInfo="pageInfo" v-on:refreshPageSize="refreshPageSize" v-on:refreshPageNum="refreshPageNum" />
        </div>
        <!-- 新增 编辑 -->
        <el-dialog :title="title" :visible.sync="addVisible" width="600px" v-if="addVisible" class="dialog_box">
            <el-form ref="form" :model="form" label-width="120px" :rules="rules" label-position="left">
                <el-form-item label="备注 " prop="remark">
                    <el-input v-model="form.remark" placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveData">确 定</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import Pagination from '@/components/Pagination';
import Url from '@/components/Url';
import loadEvents from '@/utils/loading'
import {request} from '@/common/request';
import {deal} from '@/common/main';
import {mapMutations} from 'vuex';

let loads = new loadEvents();
export default {
    components: {
        Breadcrumb,
        Pagination,
        Url
    },
    data() {
        return {
            tabPosition: 'all',
            choseState: null,
            title: '新增用户',
            addVisible: false,
            pageInfo: {},
            menuList: ['订单', '订单管理'],
            form: {
            },
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() < Date.now() - 8.64e7;
                }
            },
            rules: {
                uid: [{
                    required: true,
                    message: '备注不能为空',
                    trigger: 'blur'
                }],
            },
        }
    },

    computed: {
        queryParams: {
            set: function (newValue) {
                this.$store.commit('initQueryParams', newValue)
            },
            get: function (newValue) {
                return this.$store.state.queryParams
            },
        }
    },
    beforeRouteEnter(to, from, next) {
        console.log('dddddd', to)
        console.log('dddddd', from)
        if (from.path === '/order-orderDetails') {
            next()
        } else {
            next(vm => {
                vm.queryParams = { page: 1, pagesize: 10 }
            })
        }

    },
    created() {
        if (this.queryParams.state) {
            if (this.queryParams.state === 1) {
                this.tabPosition = 8
            }
            if (this.queryParams.state === 2) {
                this.tabPosition = 4
            }
            if (this.queryParams.state === 3) {
                this.tabPosition = 3
            }
            if (this.queryParams.state === 4) {
                this.tabPosition = 5
            }
            if (this.queryParams.state === 5) {
                this.tabPosition = 6
            }
            if (this.queryParams.state === 6) {
                this.tabPosition = 7
            }
        } else if (this.queryParams.pay_state) {
            if (this.queryParams.pay_state === 0) {
                this.tabPosition = 1
            }
            if (this.queryParams.pay_state === 2) {
                this.tabPosition = 2
            }
        } else {
            this.tabPosition = 'all'
        }
        this.loadData()
    },
    watch: {
        $route(from) {
            let ArticleEdit = from.fullPath.indexOf('/order-orderDetails')
            if (ArticleEdit !== -1) {
                this.loadData()
            }
        }
    },
    methods: {
        ...mapMutations({
            'initQueryParams': 'initQueryParams'
        }),
        // 导出
        exportFile() {
            if (this.queryParams.ctime && this.queryParams.etime) {
                let data = this.queryParams;
                data.stime = this.queryParams.ctime;
                data.etime = this.queryParams.etime

                request.get('/order/export', data).then(ret => {
                    if (ret.code === 1) {
                        this.$message.success('导出成功');
                    } else {
                        this.$message.error(ret.msg);
                    }
                });
            } else {
                this.$message.error('请选择时间');
            }
        },
        //编辑
        edit(index, row) {
            this.mode = 'edit';
            this.title = '编辑';
            this.addVisible = true;
            this.form.id = row.id
        },
        //商品列表
        loadData() {
            this.loading = true;
            let _this = this
            request.get('/order/list', this.queryParams).then(ret => {
                if (ret.code == 1) {
                    this.loading = false;
                    this.pageInfo = ret.data;
                    this.pageInfo.list = ret.data.list;
                    this.pageInfo.list.map(function (val) {
                        val.pay_time = deal.timestamp(val.pay_time, 'unix');
                        val.count = val.goods.length
                        let index = val.goods.findIndex(item =>
                            item.list.refund_id != 0
                        )
                        if (index === -1) {
                            _this.$set(val, 'refund_id', 1)
                        } else {
                            _this.$set(val, 'refund_id', 2)

                        }
                        return val;
                    })
                } else {
                    this.$message.error(ret.msg);
                }
            });
        },
        //增加编辑
        saveData() {
            if (this.$refs.form) {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        var url = '/order/remark/edit';
                        //处理时间
                        request.post(url, this.form).then(ret => {
                            if (ret.code == 1) {
                                this.addVisible = false;
                                this.loadData();
                                this.$message.success((this.mode == 'add' ? '新增' : '编辑') +
                                    '成功');
                                this.$refs.form.clearValidate()
                            } else {
                                this.$message.error(ret.msg);
                            }
                        });
                    } else {
                        this.$message.error('请补全信息');
                        return false;
                    }
                });
            };
        },
        changeQuery() {
            this.queryParams.page = 1;
            if (this.queryParams.time) {
                let arr = Object.assign({}, this.queryParams.time)
                this.queryParams.ctime = deal.timestamp(arr[0]);
                this.queryParams.etime = deal.timestamp(arr[1]);
            } else {
                delete this.queryParams.ctime
                delete this.queryParams.etime
            }
            this.loadData();
        },
        refreshPageSize(val) {
            this.queryParams.pagesize = val;
            if (this.queryParams.time) {
                let arr = Object.assign({}, this.queryParams.time)
                this.queryParams.ctime = deal.timestamp(arr[0]);
                this.queryParams.etime = deal.timestamp(arr[1]);
            } else {
                delete this.queryParams.ctime
                delete this.queryParams.etime
            }
            this.loadData()
        },
        refreshPageNum(val) {
            this.queryParams.page = val;
            if (this.queryParams.time) {
                let arr = Object.assign({}, this.queryParams.time)
                this.queryParams.ctime = deal.timestamp(arr[0]);
                this.queryParams.etime = deal.timestamp(arr[1]);
            } else {
                delete this.queryParams.ctime
                delete this.queryParams.etime
            }
            this.loadData()
        },
        changState() {
            this.queryParams.page = 1
            this.queryParams.pagesize = 10
            switch (this.tabPosition) {
                case 'all':
                    delete this.queryParams.pay_state
                    delete this.queryParams.state
                    break;
                case '1':
                    delete this.queryParams.state
                    this.queryParams.pay_state = 0
                    break;
                case '2':
                    delete this.queryParams.state
                    this.queryParams.pay_state = 2
                    this.queryParams.state = 1
                    break;
                case '3':
                    delete this.queryParams.pay_state
                    this.queryParams.state = 3
                    break;
                case '4':
                    delete this.queryParams.pay_state
                    this.queryParams.state = 2
                    break;
                case '5':
                    delete this.queryParams.pay_state
                    this.queryParams.state = 4
                    break;
                case '6':
                    delete this.queryParams.pay_state
                    this.queryParams.state = 5
                    break;
                case '7':
                    delete this.queryParams.pay_state
                    this.queryParams.state = 6
                    break;
                case '8':
                    delete this.queryParams.pay_state
                    this.queryParams.state = 1
                    break;

            }
            this.loadData()
        },
        //查看详情   
        tiao(index, row) {
            this.$router.replace({ path: '/order-orderDetails', query: { 'id': row.id } })
        },
        //发货
        goDeliver() {
            this.$router.push('deliver')
        },
        beforeAvatarUpload(file) {
            let fileName = file.name
            let pos = fileName.lastIndexOf('.')
            let lastName = fileName.substring(pos, fileName.length)
            if (lastName.toLowerCase() !== '.xlsx') {
                this.$message.error('不支持此文件格式!');
            }
            loads.open(`body`, '导入中');
        },
        handleAvatarSuccess(res, file) {
            loads.close();
            if (res.code == 1) {
                this.loadData();
            } else {
                this.$message.error(res.msg);
            }
        }
    }
};
</script>

<style  scoped>
.red {
    color: #ff0000;
}

.green {
    color: green;
}

/* 对话框样式 */

.dialog_box >>> .el-dialog__body {
    padding: 20px 30px 20px 60px;
}

.dialog_box >>> .el-dialog__header {
    padding: 30px 30px 10px;
}

.dialog_box .el-form-item--small.el-form-item {
    margin-bottom: 20px;
}
</style>